export const rowColors = {
    EVEN_ROW_COLOR: "#fcfcfc",
    GROUP_ROW_COLOR: "#e8e9eb",
    HEADER_ROW_COLOR: "#f1f2f4",
    ODD_ROW_COLOR: "#fff",
    PDF_INNER_BORDER_COLOR: "#dde2eb",
    PDF_OUTER_BORDER_COLOR: "#babfc7"
};
export const tableParams = {
    BORDER_WIDTH: 0.25,
    CELL_HEIGHT: 8,
    HEADER_HEIGHT: 16
};
export const tableStyles = {
    CURRENCY: "currency",
    TABLE_HEADER: "tableHeader",
    TABLE_TITLE: "tableTitle",
    TAGS: "tags"
};
export const fontColors = {
    PRIMARY_TEXT: "#17191c",
    SECONDARY_TEXT: "#6d7481"
};
export const quartileColors = {
    1: "#d90400",
    2: "#ff8900",
    3: "#ffbf0d",
    4: "#26732d"
};
export const variationColors = {
    NEGATIVE_VALUE: "#d90400",
    POSITIVE_VALUE: "#26732d",
    ZERO_VALUE: "#6d7481"
};
export const repRiskColors = {
    A: "#9fd926",
    AA: "#33993c",
    AAA: "#26732d",
    B: "#ff8900",
    BB: "#ff8900",
    BBB: "#ffbf0d",
    C: "#bc0300",
    CC: "#d90400",
    CCC: "#fd4f03",
    D: "#8c0200",
    NA: "#888e9a"
};
export const sparklineColumnSize = {
    HEIGHT: 25,
    WIDTH: 130
};
